<template>
  <div id="app">
    <v-app>
      <router-view class="" />
      <CookieBanner />
    </v-app>
  </div>
</template>

<script>
import CookieBanner from '@/components/CookieBanner.vue';

export default {
  name: 'App',
  components: {
    CookieBanner
  }
};
</script>

<style>
:root {
  /* 🎨 Цвета */
  --color-primary: #000000;
  --color-primary-1: #EBB970;
  --color-primary-dark: #07284b;
  --color-primary-codepopup: #383733;
  --color-primary-light: #3F1405;
  --color-primary-popup: #920F2A;
  --color-white: #FFFFFF;
  --color-accent: #f2e4b5;
  --color-error: #eb5757;
  --color-error-dark: #ad0202;
  --color-black: #020202;
  --color-number: #F1E4B2;

  /* 🔤 Шрифты */
  --font-family: "HelveticaNeueCyr", sans-serif;
  --font-family-regular: "ChivasLoud_Regular", sans-serif;
  --font-family-book: "BebasNeueBook", sans-serif;
  --font-family-bold: "HelveticaBold", sans-serif;
  --font-family-medium: "MontserratMedium", sans-serif;
  --font-family-addition: "MontserratRegulat", sans-serif;

  /* 📏 Размеры шрифтов */
  --font-size-xxl: 40px;
  --font-size-xl: 36px;
  --font-size-lg: 24px;
  --font-size-md: 20px;
  --font-size-sm: 18px;
  --font-size-xs: 16px;
  --font-size-xxs: 14px;
  --font-size-xxxs: 12px;

  /* 📦 Отступы и радиусы */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 20px;

  --padding-sm: 10px;
  --padding-md: 20px;
  --padding-lg: 42px;

  /* 🖱️ Эффекты */
  --transition-fast: 0.15s ease-out;
  --transition-normal: 0.3s ease-in-out;
  --transition-slow: 0.4s ease;
  --box-shadow-btn: 0 4px 0 var(--color-primary-dark);
  --box-shadow-btn-hover: 0 6px 0 var(--color-primary-dark);
  --box-shadow-btn-active: 0 2px 0 var(--color-primary-dark);
}
</style>
